// extracted by mini-css-extract-plugin
module.exports = {"project":"CustomPictureLabels_project__TCxbg","labels":"CustomPictureLabels_labels__wD98L","img-border":"CustomPictureLabels_img-border__s_fzm"};